import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInput } from '@/models/app';

export const fetchMissedCalls = async ({
  orderBy,
  sortType,
  pagination,
  filter,
}: {
  orderBy?: string;
  sortType?: string;
  pagination?: PaginationInput;
  filter?: {
    startDate?: string;
    endDate?: string;
  };
}) => {
  const response = await queryExecute({
    query: graphql(`
      query MissedCalls($orderBy: String, $sortType: String, $pagination: PaginationInputType, $filter: MissedCallFilterType) {
        missedCalls(orderBy: $orderBy, sortType: $sortType, pagination: $pagination, filter: $filter) {
          count
          rows {
            id
            description
            createdAt
            updatedAt
            callLog {
              id
              callerId
              fromPhoneNumber
              toPhoneNumber
              resolvedPhoneNumber
              purpose
              callerName
            }
          }
        }
      }
    `),
    variables: {
      orderBy,
      sortType,
      pagination,
      filter,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.missedCalls;
};
